import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const form: ThemedFunctor = () => css`
  textarea {
    resize: vertical;
  }
`;
